import { render } from "./DocumentIntegrationDialog.vue?vue&type=template&id=72f2cf28&lang=pug"
import script from "./DocumentIntegrationDialog.vue?vue&type=script&lang=js"
export * from "./DocumentIntegrationDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__